export const allowedBillingOperationTypeIds = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
  17, 18, 19, 23, 24, 25, 26, 27, 30, 31, 44, 45, 77, 78
];